module.exports = __webpack_public_path__ + "img/solution-electric-intro.1ced728d.png";